import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import NewMeetingDialog from "./NewMeetingDialog";
import { Button } from "primereact/button";

const MeetingsTable = ({
  dailyReport,
  setDailyReport,
  updateDailyReportMutation,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const hideDialog = () => {
    setIsVisible(false);
  };

  const header = () => {
    return (
      <div className="flex align-items-center justify-content-between gap-2">
        <span className="text-xl text-900 font-bold">Meetings</span>
        <Button
          className="w-9rem"
          label="Create"
          icon="pi pi-plus"
          onClick={() => {
            setIsVisible(true);
          }}
        />
      </div>
    );
  };

  const cellEditor = (options) => {
    if (options.field === "vendor_id") return textEditor(options);
    return textEditor(options);
  };

  const textEditor = (options) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        onKeyDown={(e) => e.stopPropagation()}
      />
    );
  };

  const onCellEditComplete = (e) => {
    let { newRowData, newValue, field, originalEvent: event, rowIndex } = e;

    let shouldUpdated = dailyReport["meetings"][rowIndex][field] !== newValue;

    if (!shouldUpdated) {
      return;
    }

    let _dailyReport = { ...dailyReport };
    _dailyReport["meetings"][rowIndex][field] = newValue;
    setDailyReport(_dailyReport);

    let updatedData = { meetings: _dailyReport["meetings"] };
    updateDailyReportMutation({
      dailyReport: updatedData,
      dailyReportId: dailyReport._id,
    });
  };

  const handleRemoveRow = (rowIndex) => {
    let _dailyReport = { ...dailyReport };
    _dailyReport.meetings.splice(rowIndex, 1);
    setDailyReport(_dailyReport);

    let updatedData = { meetings: _dailyReport["meetings"] };
    updateDailyReportMutation({
      dailyReport: updatedData,
      dailyReportId: dailyReport._id,
    });
  };

  const actionBodyTemplate = (rowData, options) => {
    const { rowIndex } = options;
    return (
      <Button
        type="button"
        icon="pi pi-times"
        rounded
        severity="danger"
        onClick={() => handleRemoveRow(rowIndex)}
        text
      />
    );
  };

  return (
    <>
      <div className="card p-fluid">
        <DataTable value={dailyReport.meetings} editMode="cell" header={header}>
          <Column
            key="meeting"
            field="meeting"
            header="Meeting"
            style={{ width: "100%" }}
            editor={(options) => cellEditor(options)}
            onCellEditComplete={onCellEditComplete}
          />
          <Column
            headerStyle={{ width: "5rem", textAlign: "center" }}
            bodyStyle={{ textAlign: "center", overflow: "visible" }}
            body={actionBodyTemplate}
          />
        </DataTable>
      </div>
      <NewMeetingDialog
        isVisible={isVisible}
        hideDialog={hideDialog}
        dailyReport={dailyReport}
        setDailyReport={setDailyReport}
      />
    </>
  );
};
export default MeetingsTable;
